module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cn":{"level":"级别"},"TW":{"level":"级别"},"en":{"level":"Level"}}')
  delete Component.options._Ctor
}
